module.exports = __webpack_public_path__ + "static/ses-2021-ceo-statement-6f6ad07f2f938c0705bc95cdd9ab2ece.pdf";